import type { TrigKey } from './keys';

export const es: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matemáticas · Trigonometría',
  'panel.experiment': 'Experimento',
  'panel.params': 'Parámetros',
  'panel.scene': 'Elige un experimento',
  'experiment.right-triangle.label': 'Triángulo rectángulo',
  'experiment.unit-circle.label': 'Círculo unitario',
  'experiment.wave-studio.label': 'Estudio de ondas',
  'experiment.identity-playground.label': 'Identidades',
  'experiment.triangle-solver.label': 'Solucionador de triángulos',
  'experiment.circular-polar.label': 'Circular y polar',
  'hint.line1': 'Arrastra puntos y mueve los deslizadores.',
  'hint.line2': 'El contenido educativo vive en la geometría, no en el texto.',
  'rt.angle.a': 'Ángulo A',
  'rt.angle.b': 'Ángulo B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radianes',
  'rt.show.sin': 'sen',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Ajustar a 30°/45°/60°',
  'uc.units': 'Unidades',
  'uc.show.sin': 'sen',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Mostrar ASTC',
  'uc.snap.common': 'Ajustar a ángulos comunes',
  'uc.angle.value': '∠',
  'uc.units.deg': 'grados',
  'uc.units.rad': 'rad',
  'uc.units.both': 'grados+rad',
  'ws.fn': 'Función',
  'ws.fn.sin': 'sen',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitud',
  'ws.frequency': 'B — Frecuencia',
  'ws.phase': 'C — Desfase',
  'ws.shift': 'D — Desplazamiento vertical',
  'ws.rform.toggle': 'Derivación forma-R',
  'ws.rform.a': 'a (coef. sen)',
  'ws.rform.b': 'b (coef. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Reiniciar',
  'ws.base': 'Mostrar curva base',
  'ip.id.pythagorean': 'Pitagórica',
  'ip.id.reciprocal': 'Recíproca',
  'ip.id.quotient': 'Cociente',
  'ip.id.sum': 'Suma',
  'ip.id.difference': 'Diferencia',
  'ip.id.double': 'Ángulo doble',
  'ip.id.half': 'Ángulo mitad',
  'ip.play': 'Reproducir',
  'ip.pause': 'Pausa',
  'ip.step': 'Paso',
  'ip.reset': 'Reiniciar',
  'ip.proof.pythagorean.summary': 'sen²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sen θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sen θ / cos θ',
  'ip.proof.sum.summary': 'sen(A+B) = sen A cos B + cos A sen B',
  'ip.proof.difference.summary': 'sen(A−B) = sen A cos B − cos A sen B',
  'ip.proof.double.summary': 'sen 2θ = 2 sen θ cos θ',
  'ip.proof.half.summary': 'sen(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Disponible en v2 — esta prueba requiere una construcción más elaborada.',
  'ts.area': 'Área',
  'ts.sineRule': 'Regla del seno',
  'ts.cosineRule': 'Regla del coseno',
  'ts.ambiguous.toggle': 'Mostrar triángulo fantasma cuando es ambiguo',
  'ts.reset': 'Reiniciar a equilátero',
  'ts.snap.integers': 'Ajustar a enteros',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Lados',
  'ts.section.angles': 'Ángulos',
  'ts.section.sineRule': 'Regla del seno',
  'ts.section.cosineRule': 'Regla del coseno',
  'ts.section.area': 'Área',
  'cp.omega': 'Velocidad angular',
  'cp.plot.y': 'Graficar y (sen)',
  'cp.plot.x': 'Graficar x (cos)',
  'cp.polar.label': 'Figura polar',
  'cp.polar.circle': 'Círculo (r = 1)',
  'cp.polar.rose': 'Rosa (r = sen 3θ)',
  'cp.polar.cardioid': 'Cardioide (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Aprox. de ángulo pequeño (sen x ≈ x)',
  'cp.play': 'Reproducir',
  'cp.pause': 'Pausa',
  'cp.reset': 'Reiniciar',
  'cp.step': 'Paso π/12',
};
